module.exports = __webpack_public_path__ + "static/media/sandbox-whatsapp.3947fea3.svg";